// extracted by mini-css-extract-plugin
module.exports = {"optionsContainer":"SegmentedControl_optionsContainer__3YCkr","option":"SegmentedControl_option__2NoHo","selected":"SegmentedControl_selected__3Xv1F"};